import { SecurityGroups, getOnboardingLink } from '@akin-home/user';
import { UserRef } from '.';
import { generateId } from '../../utils/records';

import { UserModel } from './types';

export const createUserModel = (input: Partial<UserModel>): UserModel => ({
  __typename: 'User',
  id: generateId(),
  name: '',
  sub: '',
  habitatID: '',
  username: '',
  email: '',
  securityGroups: [],
  ...input,
});

export const userHasGroup = (user: UserModel) => (group: SecurityGroups) =>
  user.securityGroups.includes(group);

export const userModelToUserRef = (user: UserModel): UserRef => ({
  id: user.id,
  name: user.name,
  habitatID: user.habitatID,
  imageUrl: user.customPictureURL || undefined,
  image: user.image,
  profileColor: user.profileColor || undefined,
  profilePicture: user.profilePicture,
});

export { getOnboardingLink };
